<section id="registro" class="registro-register">
  <app-header-public></app-header-public>

  <main class="registro-register__main">
    <div class="container registro-register__container py-3 py-md-4 py-lg-5">
      <div class="row g-2 g-sm-3 g-lg-2 justify-content-center">
        <div class="col-12 col-md-6 col-lg-6">
          <article class="registro-register__card">
            <div class="registro-register__card-image">
              <img src="assets/img/Inicio_sesion/webp/persona_natural.webp"
                alt="Persona natural - Solicita tu crédito a nombre propio" class="registro-register__card-img" />
              <img src="assets/img/Inicio_sesion/svg/log_e.svg" alt=""
                class="registro-register__card-badge registro-register__card-badge--left" aria-hidden="true" />
            </div>
            <div class="registro-register__card-body">
              <a id="btnRegistroPersonaNatural" routerLink="/microempresario/registro/persona-natural"
                class="btn registro-register__card-btn hvr-shrink">
                Soy persona natural
                <img src="assets/img/icos/cursor-default-click-outline.svg" alt=""
                  class="registro-register__card-icon" aria-hidden="true" />
              </a>
              <p class="registro-register__card-description">
                <strong>Persona natural:</strong> {{ descripcionPersonaNatural }}
              </p>
            </div>
          </article>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <article class="registro-register__card">
            <div class="registro-register__card-image">
              <img src="assets/img/Inicio_sesion/webp/persona_juridica.webp"
                alt="Persona jurídica - Solicita crédito a nombre de tu empresa" class="registro-register__card-img" />
              <img src="assets/img/Inicio_sesion/svg/log_e.svg" alt=""
                class="registro-register__card-badge registro-register__card-badge--right" aria-hidden="true" />
            </div>
            <div class="registro-register__card-body">
              <a id="btnRegistroPersonaJuridica" routerLink="/microempresario/registro/persona-juridica"
                class="btn registro-register__card-btn hvr-shrink">
                Soy persona jurídica
                <img src="assets/img/icos/cursor-default-click-outline.svg" alt=""
                  class="registro-register__card-icon" aria-hidden="true" />
              </a>
              <p class="registro-register__card-description">
                <strong>Persona jurídica:</strong> {{ descripcionPersonaJuridica }}
              </p>
            </div>
          </article>
        </div>
      </div>
    </div>
  </main>

  <app-footer-public></app-footer-public>
</section>
